
<div class="status-box" [ngClass]="boxClass">
  {{ statusText }}
</div>
